


































import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { OrderDto } from "../../../types/impl/OrderDto";
import { IOrderItemDto } from "../../../types/interface/IOrderItem";
import CheckBoxTable from "./checkbox-table.vue";
import { IOrderDto } from "../../../types/interface/IOrderDto";
import { OrderCancalType } from "./order-step-status.vue";
import { OrderItemStatus } from "../../../types/enum/OrderEnum";
@Component({
  components: {
    CheckBoxTable
  }
})
export default class ReasonBottomSheets extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ default: () => OrderDto.orderItems }) orderItems!: IOrderItemDto[];
  @Prop(String) cancelType!: OrderCancalType;

  cancelItemReason: string[] = ["Sold out", "Too busy"];

  rejectRefundReason: string[] = [
    "We apologize that our food standards have not met your expectations.",
    "We apologize. Hope to see you next time.",
    "We apologize. Hope our other dishes will satisfy you."
  ];

  merchantRefundReason: string[] = [
    "Missing items",
    "Items made incorrectly",
    "Poor food quality"
  ];

  reason: string = "";

  selectItems: Array<string> = [];

  isCheckBoxTableShow: boolean = true;

  refundFlag: boolean = false;

  onSelect(selection: Array<string>) {
    this.selectItems = selection;
  }

  public get showSelect(): boolean {
    switch (this.cancelType) {
      case OrderCancalType.OrderCancel:
        return true;
      case OrderCancalType.RefundCancel:
        return true;
      case OrderCancalType.MerchantCancel:
        return false;
      case OrderCancalType.OrderReject:
        return false;
      case OrderCancalType.MerchantRefund:
        return true;
    }
  }

  public get isRefund(): boolean {
    if (!this.orderItems || !this.orderItems.length) {
      return false;
    } else if (
      this.orderItems[0].status === OrderItemStatus.ComplainRequested
    ) {
      return true;
    } else {
      return false;
    }
  }

  public get show(): boolean {
    return this.value;
  }

  public set show(v: boolean) {
    this.$emit("input", v);
  }
  refund: number | string = 0;
  submit() {
    if (!this.reason) {
      this.$message.show({
        text: "Reason can not be empty"
      });
      return;
    }

    if (this.reason.length >= 150) {
      return;
    }

    if (this.showSelect && !this.selectItems.length) {
      this.$message.show({
        text: "Please select the food"
      });
      return;
    }

    if (this.refundFlag && this.refund <= 0) {
      this.$message.show({
        text: `Refund must be more than 0%`
      });
      return;
    }

    if (this.refundFlag) {
      this.$emit("on-submit", {
        reason: this.reason,
        selectItems: this.selectItems,
        refund: this.refund
      });
    } else {
      this.$emit("on-submit", {
        reason: this.reason,
        selectItems: this.selectItems
      });
    }
    this.close();
  }

  changeRefund() {
    if (Number(this.refund) > 100) {
      this.refund = 100;
    }
    this.refund.toString().indexOf(".") === 2
      ? (this.refund = `${this.refund}`.substring(0, 5))
      : (this.refund = `${this.refund}`.substring(0, 4));

    if (isNaN(Number(this.refund)) || this.refund.toString() === "") {
      this.refund = 0;
    }
    if (
      this.refund.toString().indexOf("0") === 0 &&
      this.refund.toString().indexOf(".") !== 1
    ) {
      this.refund = Number(this.refund);
    }
    if (Number(this.refund) === 100) {
      this.refund = `${this.refund}`.substring(0, 3);
    }
  }

  close() {
    const checkBoxTable = this.$refs.checkBoxTable as Element;
    checkBoxTable.selected = [];
    this.reason = "";
    this.show = false;
    this.refund = 0;
    this.selectItems = [];
  }

  showCheckBoxTable() {
    this.isCheckBoxTableShow = true;
  }

  hideCheckBoxTable() {
    if (!this.$store.state.isPc) this.isCheckBoxTableShow = false;
  }

  rules: { [key: string]: (value: any) => string | boolean } = {
    length: (value: string) =>
      value.length * 1 <= 150 || "Content length cannot exceed 150"
  };

  @Watch("show")
  showRefundInput() {
    if (`${this.cancelType}` === OrderCancalType.MerchantRefund) {
      this.refundFlag = true;
    }
  }

  //  解决打包后 v-model 不生效问题
  handleTextareakeyup(e: any) {
    let str = e.target.value;
    if (!str) {
      return;
    }
    this.reason = str;
  }

  // updated() {
  //   if (`${this.cancelType}` === OrderCancalType.MerchantRefund) {
  //     this.refundFlag = true;
  //   }
  // }
}
